import { css, Global, ThemeProvider } from '@emotion/react';
import * as React from 'react';
import { Navigate, Route, Routes as RoutesElement } from 'react-router-dom';
import { ENV } from '../env';
import { useSystem } from '../hooks/useSystem';
import { LayersWidget } from '../layers/LayersWidget';
import { NotFound } from '../pages/NotFound';
import { NavigateExternal } from '../pages/NavigateExternal';
import { AdminLandingPage } from '../pages/admin/AdminLandingPage';
import { ProfileLandingPage } from '../pages/profile/ProfileLandingPage';
import { SignupPage } from '../pages/signup/SignupPage';
import { StartBuildingPage } from '../pages/start-building/StartBuildingPage';
import { styled } from '../theme';
import { Routes } from '../routes';
import { generatePath } from '../utils/paths';
import { Product } from '@journeyapps-platform/types-accounts';

const backdrop = require('../../media/banner.png');

export const BodyWidget: React.FC = (props) => {
  const system = useSystem();

  const getRoutes = () => {
    if (ENV.USER_ID) {
      return [
        <Route path="/" element={<Navigate to="admin" replace={true} />} />,
        <Route path="admin/:org_id/*" element={<AdminLandingPage />} />,
        <Route
          path="admin/plans"
          element={
            <Navigate
              to={generatePath(Routes.MANAGE_PLANS, {
                org_id: ENV.USER_ORG
              })}
              replace={true}
            />
          }
        />,
        <Route path="admin" element={<AdminLandingPage />} />,
        <Route path="profile" element={<ProfileLandingPage />} />,
        <Route path="profile/*" element={<ProfileLandingPage />} />,
        // deprecated
        <Route path="free-trial" element={<Navigate to="/admin" replace={true} />} />,
        // deprecated
        <Route path="get-started" element={<Navigate to="/admin" replace={true} />} />,

        <Route path="platform-signup" element={<Navigate to="/admin" replace={true} />} />,
        ...(ENV.PS_DASHBOARD_DEFAULT === 'true'
          ? [<Route path="powersync-signup" element={<NavigateExternal to={ENV.PS_DASHBOARD_URL} />} />]
          : [<Route path="powersync-signup" element={<Navigate to="/admin" replace={true} />} />]),

        <Route path="signup" element={<Navigate to="/admin" replace={true} />} />,

        <Route path="*" element={<NotFound backPath={'admin'} />} />
      ];
    }
    return [
      // deprecated
      <Route path="free-trial" element={<StartBuildingPage />} />,
      // deprecated
      <Route path="get-started" element={<StartBuildingPage />} />,

      <Route path="platform-signup" element={<StartBuildingPage product={Product.APP} />} />,
      <Route path="powersync-signup" element={<StartBuildingPage product={Product.POWERSYNC} />} />,

      <Route path="signup" element={<SignupPage />} />,
      <Route path="*" element={<NotFound backPath={'free-trial'} />} />
    ];
  };

  return (
    <>
      <Global
        styles={css`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Open Sans', sans-serif;
          }

          html,
          body,
          #application {
            height: 100%;
            background: #1b1b1d;
          }
        `}
      />
      <ThemeProvider theme={system.theme}>
        <S.Container>
          <S.Backdrop />
          <S.Content>
            <RoutesElement>
              {getRoutes().map((r, index) => {
                return <React.Fragment key={index}>{r}</React.Fragment>;
              })}
            </RoutesElement>
          </S.Content>
        </S.Container>
        <LayersWidget />
      </ThemeProvider>
    </>
  );
};

namespace S {
  export const Container = styled.div`
    height: 100%;
    background: rgb(27, 27, 29);
  `;

  export const Backdrop = styled.div`
    pointer-events: none;
    height: 100%;
    background-image: url(${backdrop});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;
    position: fixed;
    width: 100%;
  `;

  export const Content = styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  `;
}
